var _rect, _g, _circle, _circle2, _path, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfiePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 142,
    viewBox: "0 0 212 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 211,
    height: 140.108,
    rx: 5.5,
    fill: "#FCFCFC",
    stroke: "#E4E4E4",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2145_1236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.0586,
    y: 17.7197,
    width: 173.885,
    height: 105.669,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.294 77.172V67.5103H93.2695V77.172L105.811 88.1722L118.294 77.172Z",
    fill: "#FEE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.441 78.8137C120.174 78.7637 119.92 78.6611 119.692 78.512L105.755 86.5745L92.3643 78.1079C92.0182 78.4097 91.5715 78.6552 91.1249 78.7984L73.9478 82.8305C72.734 83.1127 71.6512 83.7966 70.875 84.7715C70.0989 85.7464 69.6749 86.9549 69.6719 88.201V99C69.6719 100.541 70.0163 124.083 71.5575 124.083H140.743C142.284 124.083 141.938 100.541 141.938 99V88.201C141.938 85.6675 140.153 83.4204 137.662 82.8305L120.443 78.8137H120.441Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2695 67.5102V77.6613C109.052 83.2909 118.252 69.1947 118.252 69.1947V67.4966H93.2712",
    fill: "#F5DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8945 35.8618L90.0897 61.3913C90.192 63.7816 91.3854 65.9707 93.329 67.4096L98.9024 71.5423C100.299 72.5926 101.983 73.1399 103.726 73.1399H109.096C110.839 73.1399 112.537 72.5943 113.921 71.5423L119.493 67.4096C121.436 65.9707 122.573 63.7816 122.732 61.3913L123.925 35.8618H88.8962",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.312 111.657H155.735L156.137 124.054H152.797L149.312 111.657Z",
    fill: "#F9E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0391 109.368C65.3532 109.814 70.5361 110.965 73.5163 112.808V124.112H58.0391V109.368Z",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.904 84.5439C140.904 84.5439 143.984 86.0852 145.524 87.6247C146.576 88.6767 148.606 92.1036 151.703 97.8781C153.244 102.413 156.323 109.325 156.323 111.615C144.978 116.235 138.902 118.583 138.154 118.583C136.858 115.991 133.92 110.375 129.341 101.665V97.8781C129.341 95.9345 130.19 94.0472 131.631 92.7514C137.865 87.2786 140.904 84.5439 140.904 84.5439ZM71.3139 84.5439C71.3139 84.5439 68.2331 86.0852 66.6936 87.6247C65.6417 88.6767 63.6111 92.1036 60.515 97.8781C58.9737 102.413 55.7344 110.864 55.7344 113.212C66.8368 116.293 72.7546 117.832 73.5457 117.832C74.8414 115.241 77.9239 108.575 82.8477 97.8781C82.8477 95.9345 81.9986 94.0472 80.558 92.7514L71.3139 84.5439Z",
    fill: "#E3E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24 124.054H102.328L103.177 89.311H108.404L109.24 108.273",
    fill: "#C7CDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8398 84.0991H111.791V93.2119H99.8398V84.0991Z",
    fill: "#C7CDE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0698 75.2846L105.754 86.6325C105.754 86.6325 102.229 88.4176 97.7925 92.003C96.9008 92.7515 95.5045 92.4497 95.0578 91.4131L89.082 78.425L90.9677 75.6307C91.4723 74.8396 92.4663 74.681 93.0698 75.2863M118.499 75.2863L105.814 86.6325C105.814 86.6325 109.342 88.4176 113.776 92.003C114.668 92.7515 116.066 92.4497 116.511 91.4131L122.486 78.425L120.601 75.6307C120.096 74.8396 119.104 74.681 118.499 75.2863Z",
    fill: "#E3E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.223 27.8998L115.518 37.0143C121.436 38.2078 122.343 47.4092 122.43 50.0587C122.43 50.5633 122.631 51.01 122.877 51.3987L125.165 54.8836C125.165 54.8836 124.374 49.109 127.959 45.2218C127.915 45.2644 129.153 22.4271 114.223 27.8998Z",
    fill: "#9499AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.561 54.3209L124.964 60.5422C124.87 60.9032 124.656 61.2218 124.358 61.4465C124.06 61.6711 123.695 61.7886 123.322 61.7799C122.918 61.7887 122.525 61.6456 122.221 61.3789C121.917 61.1122 121.724 60.7413 121.68 60.3393L120.889 53.9765C120.844 53.5769 120.884 53.1722 121.006 52.7889C121.127 52.4057 121.329 52.0523 121.596 51.752C121.864 51.4517 122.191 51.2111 122.558 51.046C122.925 50.8808 123.322 50.7948 123.724 50.7935C125.625 50.7935 127.008 52.5359 126.561 54.3226",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0394 25.4669L91.0836 26.8633C81.7815 33.688 83.5239 45.3224 83.5239 45.3224C86.3166 48.0571 86.3166 54.9842 86.3166 54.9842L89.111 52.2478C89.111 52.2478 88.0164 44.2858 93.2863 41.2476C98.1675 38.4107 102.401 39.8496 106.721 39.8496C118.369 39.8496 121.608 35.5174 121.061 30.1895C120.759 27.4532 116.526 21.7229 105.785 21.9241C101.438 21.9821 93.271 23.2778 89.0394 25.4669Z",
    fill: "#9499AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9949 38.598C88.9949 38.598 87.5559 32.8234 91.7892 26.8477C82.7753 33.6741 84.4751 45.3068 84.4751 45.3068C87.1672 48.0432 87.1672 54.9686 87.1672 54.9686L89.8593 52.2339C89.8593 52.2339 88.8073 44.2719 93.8914 41.232C98.614 38.3968 102.747 39.8357 106.936 39.8357C108.779 39.8357 110.378 39.6925 111.817 39.4913C103.078 39.7505 97.9508 33.0263 88.9949 38.598Z",
    fill: "#9499AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.555 54.3209L87.1525 60.5422C87.3554 61.2906 88.0032 61.7799 88.7943 61.7799C89.1986 61.7887 89.5915 61.6456 89.8954 61.3789C90.1994 61.1122 90.3923 60.7413 90.4362 60.3393L91.2272 53.9765C91.2736 53.5766 91.2349 53.1714 91.1136 52.7876C90.9923 52.4037 90.7912 52.0498 90.5234 51.7492C90.2556 51.4486 89.9273 51.208 89.5599 51.0433C89.1926 50.8785 88.7945 50.7934 88.392 50.7935C86.4483 50.7935 85.1083 52.5359 85.555 54.3226",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.121 98.9712C113.371 98.9712 112.723 99.5628 112.723 100.369V117.245H125.22V100.369C125.22 99.6191 124.632 98.9712 123.825 98.9712H114.121Z",
    fill: "#E3E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.046 96.3368C129.255 94.7376 120.341 90.7072 119.55 89.0654C118.758 87.4678 117.116 84.2404 123.581 87.4678C130.046 90.7072 136.526 95.5304 137.317 96.3215C138.168 97.1279 130.897 97.9787 130.046 96.3368ZM139.205 116.697C137.505 116.697 132.38 113.313 127.253 112.464C122.126 111.615 117.044 111.615 116.152 110.764C115.302 109.915 118.686 107.381 125.512 108.23C132.336 109.079 131.486 103.997 133.171 101.406C134.308 99.7057 137.706 101.707 143.38 107.381C141.738 113.601 140.355 116.697 139.203 116.697H139.205Z",
    fill: "#FEE9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.544 124.054C146.172 101.361 145.178 101.118 141.796 97.1298C139.26 96.279 126.46 96.279 125.626 97.1298C124.775 97.9788 124.775 104.79 127.324 107.337C129.858 109.872 133.3 107.337 134.149 106.488C134.998 105.639 129.873 105.639 129.873 104.79C129.873 103.939 130.722 103.939 131.571 103.939H134.106C134.106 103.939 136.64 108.173 136.64 110.764C136.64 113.299 137.735 123.406 138.181 124.054H153.544Z",
    fill: "#FFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68 98.7271H119.145V105.739H112.68V98.7271Z",
    fill: "#E3E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.695 100.412H117.159V105.739H110.695V100.412Z",
    fill: "#E3E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4575 81.629H121.957C122.238 81.6267 122.516 81.6802 122.776 81.7867C123.036 81.8931 123.272 82.0502 123.471 82.2488C123.67 82.4475 123.827 82.6837 123.933 82.9437C124.04 83.2037 124.093 83.4823 124.091 83.7632V116.037C124.093 116.319 124.04 116.597 123.933 116.858C123.826 117.118 123.669 117.354 123.47 117.553C123.271 117.752 123.035 117.909 122.774 118.015C122.514 118.121 122.235 118.174 121.954 118.172H64.4546C64.1736 118.174 63.8951 118.12 63.6351 118.014C63.3751 117.908 63.1389 117.75 62.9402 117.552C62.7416 117.353 62.5845 117.117 62.4781 116.857C62.3716 116.597 62.318 116.318 62.3204 116.037V83.7602C62.3184 83.4793 62.3724 83.2008 62.4792 82.941C62.586 82.6811 62.7434 82.4451 62.9423 82.2468C63.1412 82.0484 63.3777 81.8916 63.6378 81.7855C63.8979 81.6795 64.1766 81.6263 64.4575 81.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4358 100.682C83.2312 101.987 81.6275 102.64 79.6233 102.64H75.2231V88.5996H79.6233C84.0355 88.5996 86.2416 90.8814 86.2416 95.4439C86.2416 97.6303 85.6393 99.3761 84.4358 100.682ZM82.2702 92.3249C81.5859 91.558 80.6248 91.1745 79.3893 91.1745H78.0208V100.075H79.4071C80.6201 100.075 81.5716 99.6632 82.2606 98.841C82.9509 98.0188 83.2966 96.8995 83.2966 95.4831C83.2966 94.1449 82.9544 93.0929 82.2702 92.3249ZM69.6016 88.5996H72.3992V102.64H69.6016V88.5996Z",
    fill: "#D0D4DD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.54414,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 119 93.6294)",
    fill: "#8993A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.54414,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 119 88)",
    fill: "#8993A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.54414,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 119 99.2588)",
    fill: "#8993A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.7684,
    height: 2.57894,
    rx: 1,
    transform: "matrix(-1 0 0 1 119 109.147)",
    fill: "#8993A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.1999,
    height: 2.57894,
    rx: 1,
    transform: "matrix(-1 0 0 1 109.199 109.147)",
    fill: "#CCD2E1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9284,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 113.32 93.6294)",
    fill: "#CCD2E1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.38422,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 113.32 88)",
    fill: "#CCD2E1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.3126,
    height: 2.81461,
    rx: 1,
    transform: "matrix(-1 0 0 1 113.32 99.2588)",
    fill: "#CCD2E1"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.998,
    cy: 70.554,
    r: 24.0764,
    fill: "#0FC000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.998,
    cy: 70.554,
    r: 23.5764,
    stroke: "#0FC000",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6755 64.3119H98.9862C99.3969 64.3119 99.7787 64.1041 99.9964 63.7619L100.932 62.2911C101.367 61.6067 102.131 61.1909 102.952 61.1909H109.047C109.869 61.1909 110.633 61.6067 111.068 62.2911L112.004 63.7619C112.221 64.1041 112.603 64.3119 113.014 64.3119H116.324C117.64 64.3119 118.707 65.3599 118.707 66.6527V77.5763C118.707 78.869 117.64 79.917 116.324 79.917H95.6755C94.3597 79.917 93.293 78.869 93.293 77.5763V66.6527C93.293 65.3599 94.3597 64.3119 95.6755 64.3119Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.001,
    cy: 71.8916,
    r: 4.01274,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.001,
    cy: 71.8916,
    r: 4.51274,
    stroke: "#0FC000",
    strokeOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2145_1236",
    x: 14.0586,
    y: 15.7197,
    width: 183.887,
    height: 115.669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.9125 0 0 0 0 0.9125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2145_1236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2145_1236",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfiePhoto);
export default __webpack_public_path__ + "static/media/selfie-photo.3a52b58963b5ccad163fc059052c7d19.svg";
export { ForwardRef as ReactComponent };